import React, { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import useAxios from 'axios-hooks';
import './CmsTools.scss';

// CmsTools is a component that allows passing in:
// id: the data opject id
// type: folder name of data object container (medias, blocks, chunks, etc)
// subtype: for assets, specifying the type of asset, so we know which type of file to open.
const CmsTools = ({ id, type, subtype }) => {
  let { language } = useSelector(
    state => ({ language: state.CourseState.language }),
    shallowEqual
  );

  // Call off to development backend (competency-start)
  const [{ data }, open] = useAxios(
    {
      url: `/content/vscode-open?id=${id}&type=${type}&subtype=${subtype}&language=${language.code}`,
      method: 'GET'
    },
    { manual: true }
  );

  let colors = {
    modules: '#64bbe3',
    blocks: '#00bceb',
    chunks: '#1e4471',
    medias: '#fbab18',
    assets: '#6ebe4a'
  };

  useEffect(() => {
    if (data) {
      // eslint-disable-next-line no-console
      console.log(data);
    }
  }, [data]);

  if (process.env.NODE_ENV !== 'development') return '';
  return (
    <div className="cms-tools">
      <div
        title={`Open ${type.slice(0, -1)} with ID of ${id}`}
        className="btn btn--icon btn--small btn--secondary"
        style={{
          display: 'flex',
          backgroundColor: colors[type],
          color: '#ffffff',
          boxShadow: 'inset 0 0 0 1px #ffffff'
        }}
        onClick={e => {
          e.preventDefault();
          open();
        }}
      >
        <span className="icon-file-code-o"></span>
      </div>
    </div>
  );
};

export default CmsTools;
